import { useQuery } from '@tanstack/react-query'
import { endOfDay, format } from 'date-fns'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getCrossSellingHotels } from '../api/getCrossSellingHotels'

export const useCrossSellingHotels = () => {
	const location = useCartStore.use.location()
	const { startDate, nights, endDate } = useCartStore.use.travelPeriod()
	const roomConfigurations = useCartStore.use.roomConfigurations()

	const enabled = Boolean(location && startDate && endDate)

	const rooms = roomConfigurations.map((room) => ({
		adults: room.adults,
		children: room.children,
	}))

	return useQuery({
		queryKey: [
			'GET_CROSS_SELLING_HOTELS',
			location!.hotelCode,
			startDate,
			endDate,
			nights,
			rooms,
		],
		queryFn: () =>
			getCrossSellingHotels({
				hotelCode: location!.hotelCode!,
				arrivalDate: format(endOfDay(startDate!), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
				nights,
				rooms,
			}),
		enabled,
	})
}
